import { render, staticRenderFns } from "./ConfirmToken.vue?vue&type=template&id=73c2a417&scoped=true&"
import script from "./ConfirmToken.vue?vue&type=script&lang=js&"
export * from "./ConfirmToken.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmToken.vue?vue&type=style&index=0&id=73c2a417&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2a417",
  null
  
)

export default component.exports